// ============================================================
// BNZ Solutions — Central Business Config
// Update these values anytime; they reflect across the whole site.
// Replace PLACEHOLDER values (address / map) with real data later.
// ============================================================

export const site = {
  name: "BNZ Solutions",
  tagline: "Transforming Workspaces. Elevating Brands.",
  positioning: "Premium Office Branding & Signage Partner for Businesses",
  subServices: ["Office Branding", "Signage", "Commercial Printing", "Corporate Identity"],

  email: "zubair@bnzsolution.com",
  phone: "+91 98866 01233",
  phoneRaw: "+919886601233", // used for tel: and wa.me
  whatsapp: "919886601233", // used for wa.me links (no +)

  // PLACEHOLDER — update later without touching layout
  address: {
    line1: "PLACEHOLDER — Add Building / Street",
    line2: "PLACEHOLDER — Area",
    city: "Bengaluru",
    state: "Karnataka",
    country: "India",
    pincode: "PLACEHOLDER",
  },

  // PLACEHOLDER — replace with your Google Maps embed URL later
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248849.886539525!2d77.35073573863585!3d12.95384772232116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670c9b44e6d%3A0xf8dfc3e8517e4fe0!2sBengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1700000000000",

  serviceAreas: ["Bengaluru", "Bangalore", "Karnataka"],

  socials: {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
  },
};

// Prefilled WhatsApp helper
export const waLink = (message) =>
  `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(message || "Hi BNZ Solutions, I'd like to enquire about your branding & signage services.")}`;

export const telLink = `tel:${site.phoneRaw}`;
export const mailLink = (subject, body) =>
  `mailto:${site.email}?subject=${encodeURIComponent(subject || "Enquiry — BNZ Solutions")}${body ? `&body=${encodeURIComponent(body)}` : ""}`;
